// @mui
import { styled, alpha } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
//
import { NavItemMobileProps } from '../types';

// ----------------------------------------------------------------------

type ListItemProps = Omit<NavItemMobileProps, 'item'>;

export const ListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})<ListItemProps>(({ active, theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.text.secondary,
  height: 48,
  borderRadius: theme.shape.borderRadius,
  '& .MuiListItemIcon-root': {
    minWidth: 36,
    color: 'inherit',
  },
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.06)
        : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity * 0.7),
  },
  // Active
  ...(active && {
    color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main,
    ...theme.typography.subtitle2,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.12)
        : alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
  }),
}));
